import createRoute          from '@widesk-ui/tools/createRoute';
import ProductTemplateModel from '@models/shop/ProductTemplateModel';

export default createRoute.dashboard('/product_templates', 'shop', 'ProductTemplateDashboard', ProductTemplateModel.localize());
